/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getCapabilities.defs'
export { main as default } from './getCapabilities.defs'
